import React from 'react';
import { useTranslation } from 'react-i18next';

const WeightHeightInputs = ({
  slideCode,
  slideValues,
  groupedTextInputs,
  handleValueChange,
}) => {
  const { t } = useTranslation();
  const weightPlaceholder = t('Quiz_WeightKg');
  const heightPlaceholder = t('Quiz_HeightCm');

  return (
    <div className="t-flex t-flex-row t-gap-2.5">
      {groupedTextInputs.map((ctrl) => (
        <input
          key={`gtext-${ctrl.name}`}
          type="number"
          id={ctrl.name}
          placeholder={ctrl.name === 'weight' ? weightPlaceholder : heightPlaceholder}
          value={slideValues[slideCode]?.[ctrl.name]?.value ?? ''}
          onChange={(e) => handleValueChange(ctrl, ctrl.name, e.target.value)}
          className="t-flex-1 t-min-w-0 t-max-w-[50%] t-py-3.5 t-px-4 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-base t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal placeholder:t-text-g300"
        />
      ))}
    </div>
  );
};

export default WeightHeightInputs;
